<template>
  <div class="h-full flex flex-col justify-between bg-white p-5 rounded-md">
    <div class="info-container">
      <div v-show="data" class="flex items-center h-auto mb-2 gap-1">
        <p class="cb-text-copy-regular">{{title}}</p>
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask0_4687_6231"
            style="mask-type: alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="12"
            height="12"
          >
            <rect width="12" height="12" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_4687_6231)">
            <path
              d="M5.49997 8.49988H6.49997V5.49988H5.49997V8.49988ZM5.99997 4.49988C6.14164 4.49988 6.26047 4.45188 6.35647 4.35588C6.45214 4.26021 6.49997 4.14155 6.49997 3.99988C6.49997 3.85821 6.45214 3.73938 6.35647 3.64338C6.26047 3.54771 6.14164 3.49988 5.99997 3.49988C5.8583 3.49988 5.73964 3.54771 5.64397 3.64338C5.54797 3.73938 5.49997 3.85821 5.49997 3.99988C5.49997 4.14155 5.54797 4.26021 5.64397 4.35588C5.73964 4.45188 5.8583 4.49988 5.99997 4.49988ZM5.99997 10.9999C5.3083 10.9999 4.6583 10.8685 4.04997 10.6059C3.44164 10.3435 2.91247 9.98738 2.46247 9.53738C2.01247 9.08738 1.6563 8.55821 1.39397 7.94988C1.1313 7.34155 0.999969 6.69155 0.999969 5.99988C0.999969 5.30821 1.1313 4.65821 1.39397 4.04988C1.6563 3.44155 2.01247 2.91238 2.46247 2.46238C2.91247 2.01238 3.44164 1.65604 4.04997 1.39338C4.6583 1.13104 5.3083 0.999878 5.99997 0.999878C6.69164 0.999878 7.34164 1.13104 7.94997 1.39338C8.5583 1.65604 9.08747 2.01238 9.53747 2.46238C9.98747 2.91238 10.3436 3.44155 10.606 4.04988C10.8686 4.65821 11 5.30821 11 5.99988C11 6.69155 10.8686 7.34155 10.606 7.94988C10.3436 8.55821 9.98747 9.08738 9.53747 9.53738C9.08747 9.98738 8.5583 10.3435 7.94997 10.6059C7.34164 10.8685 6.69164 10.9999 5.99997 10.9999ZM5.99997 9.99988C7.11664 9.99988 8.06247 9.61238 8.83747 8.83738C9.61247 8.06238 9.99997 7.11655 9.99997 5.99988C9.99997 4.88321 9.61247 3.93738 8.83747 3.16238C8.06247 2.38738 7.11664 1.99988 5.99997 1.99988C4.8833 1.99988 3.93747 2.38738 3.16247 3.16238C2.38747 3.93738 1.99997 4.88321 1.99997 5.99988C1.99997 7.11655 2.38747 8.06238 3.16247 8.83738C3.93747 9.61238 4.8833 9.99988 5.99997 9.99988Z"
              fill="#64648C"
            />
          </g>
        </svg>
      </div>

      <div class="flex items-center mb-4 gap-5 ">
        <h4 class="cb-text-h4 w-auto" v-show="data">{{data}}</h4>
        <slot></slot>
      </div>
    </div>

    <p  v-show="data" class="cb-text-copy-small">
      Additional text goes here
    </p>

  </div>
</template>

<script>

export default {
  name: "InsightCard",
  props:{
        title: String,
        data:String,
    }
};
</script>